import { useApiQuery } from "app/modules/api-client";
import type { Data } from "app/modules/api-client/queryTypes";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { useAdvertiserActivityDataAndParams } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useAdvertiserActivityDataAndParams";

export type ICountriesResponse = Data<"AdIntelligenceMediaPartners", "adIntelligenceAdvertiserWorldMapDataList">;

type MethodName = "adIntelligenceAdvertiserWorldMapDataList" | "adIntelligenceAdvertiserWorldMapMergedDataList";

export const useCountries = (methodName: MethodName = "adIntelligenceAdvertiserWorldMapDataList") => {
    const params = useAdvertiserActivityDataAndParams();
    const { from, to, isWindow } = DurationService.getDurationData(params.duration).forAPI;

    return useApiQuery(
        {
            tag: "AdIntelligenceMediaPartners",
            methodName,
        },
        {
            key: params.key.split(","),
            from,
            to,
            isWindow,
            ...(isWindow ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {}),
        },
    );
};
